import { useClientPortalAPI } from "@certn/api";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { queryParamsToApiParams } from "../../utils";
import { LegacyCasesTable } from "../components/LegacyCasesTable";

export function LegacyCasesHRTab() {
  const { params } = useQueryParams();
  const { data, isLoading, error } = useClientPortalAPI(
    "/api/internal/client-portal/legacy-case/" as any,
    queryParamsToApiParams({ ...params, team_type: "HR" })
  );

  return (
    <LegacyCasesTable
      cases={data}
      isLoading={isLoading}
      error={error}
      teamType="HR"
    />
  );
}
